import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { BasePagedTableComponent } from '../../../../core/layout/components/abstracts/base-paged-table.component';
import { ICard } from '../../core/interfaces/ICard';
import { CardsService } from '../../core/services/CardsService';
import { Observable } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { IPagedResults } from '../../../../core/interfaces/IPagedResults';
import { PagedTableComponent } from '../../../../shared/components/paged-table/paged-table.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { NgTemplateOutlet } from '@angular/common';
import { ICardTicketHistoryRecord } from '../../core/interfaces/ICardTicketHistoryRecord';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';
import { ArraySlicePipe } from '../../../../shared/pipes/array-slice.pipe';
import { NumberToCurrencyPipe } from '../../../../shared/pipes/number-to-currency.pipe';

@Component({
  selector: 'app-card-tickets-history-table',
  standalone: true,
  imports: [
    PagedTableComponent,
    TranslatePipe,
    NgTemplateOutlet,
    LocaleDatetimeFormatPipe,
    ArraySlicePipe,
    NumberToCurrencyPipe
  ],
  templateUrl: './card-tickets-history-table.component.html',
  styleUrl: './card-tickets-history-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardTicketsHistoryTableComponent extends BasePagedTableComponent<ICardTicketHistoryRecord> {

  @Input({ required: true }) card: ICard;

  private readonly _cardsService = inject(CardsService);

  protected override get data$(): Observable<IResponse<IPagedResults<ICardTicketHistoryRecord>>> {
    return this._cardsService.getCardTicketsHistory(this.card.cardId, this.pagination);
  }
}
